import { cn } from "@/lib/utils";
import Image, { StaticImageData } from "next/image";

export default function SubPageHeaderImage({
  imgSrc,
  bottomGradient,
}: {
  imgSrc: string | StaticImageData;
  bottomGradient?: boolean;
}) {
  return (
    <div className="relative -mx-6 flex h-100 items-center justify-center overflow-hidden lg:h-140">
      <div
        className={cn("absolute z-10 h-full w-full", {
          "bg-gradient-to-t from-[#0F6053] from-0% to-25%": bottomGradient,
        })}
      ></div>
      <Image
        src={imgSrc}
        alt="header image"
        className="w-full object-cover object-[75%_center] md:object-center lg:scale-100"
        fill
        sizes="100vw"
        fetchPriority="high"
        priority
      />
    </div>
  );
}
